"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var format_price_1 = __importDefault(require("../../utils/format-price"));
var app_1 = require("./app");
var useContext = React.useContext, useMemo = React.useMemo;
var buttonWidth = 108;
var NavBar = function (_a) {
    var history = _a.history;
    var _b = useContext(app_1.AppContext), canGoNext = _b.canGoNext, frequency = _b.frequency, existingCustomerNewBundleParams = _b.existingCustomerNewBundleParams, isEditingExistingBundle = _b.isEditingExistingBundle, isSubmittingBundle = _b.isSubmittingBundle, pathBack = _b.pathBack, pathNext = _b.pathNext, submitBundle = _b.submitBundle, totalBundlePrice = _b.totalBundlePrice, shippingIntervalUnitType = _b.shippingIntervalUnitType, existingCustomerNewBundleSavings = _b.existingCustomerNewBundleSavings;
    var _c = __read(useMemo(function () {
        var priceAfterExistingCustomerNewBundleDiscount = (totalBundlePrice || 0) - (existingCustomerNewBundleSavings || 0);
        var price = (0, format_price_1.default)(priceAfterExistingCustomerNewBundleDiscount);
        var matches = price.match(/^(.+?)\.(.+)$/);
        return matches ? matches.slice(1) : [null, null];
    }, [totalBundlePrice, existingCustomerNewBundleSavings]), 2), dollars = _c[0], cents = _c[1];
    var goBack = function () {
        if (pathBack) {
            history.push(pathBack);
        }
    };
    var goNext = function () {
        if (canGoNext && pathNext) {
            history.push(pathNext);
        }
    };
    return (React.createElement("div", { className: 'flex-container align-middle align-stretch bg-white z1', style: { boxShadow: '0px -7px 13px 5px rgba(0, 0, 0, 0.05)', height: 55 } },
        React.createElement("button", { className: 'flex-container align-center align-middle', onClick: goBack, style: { width: buttonWidth } }, pathBack ? '← Back' : null),
        React.createElement("div", { className: 'flex-child-auto text-center flex-container flex-dir-column align-center' }, dollars && cents && frequency ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'padding-top-2' },
                React.createElement("span", { className: 'font-bold lh1', style: { fontSize: 33 } }, dollars),
                React.createElement("sup", { style: { top: -17 } }, cents)))) : null),
        React.createElement("button", { className: (0, classnames_1.default)('text-white', canGoNext ? 'bg-sandy-brown' : 'bg-nobel'), onClick: pathNext ? goNext : submitBundle, disabled: isSubmittingBundle || !canGoNext, style: { width: buttonWidth } }, (function () {
            if (isSubmittingBundle) {
                return 'Wait...';
            }
            else if (pathNext) {
                return 'Next →';
            }
            else if (isEditingExistingBundle) {
                return 'Save';
            }
            else if (existingCustomerNewBundleParams) {
                return 'Place Order';
            }
            return 'Add To Cart';
        })())));
};
exports.default = (0, react_router_dom_1.withRouter)(NavBar);
